import React from 'react';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const L = (lang, el, en) => (lang === 'el' ? el : en);
export const CATEGORIES = ['cleaning', 'garden', 'maintenance', 'safety', 'management', 'suggestion', 'complaint', 'other'];
export const CAT_LABEL = {
  el: { cleaning: 'Καθαριότητα Κοινόχρηστων Χώρων', garden: 'Κήπος & Εξωτερικοί Χώροι', maintenance: 'Συντήρηση & Επισκευές Κτιρίου', safety: 'Ασφάλεια & Προστασία Κτιρίου', management: 'Διαχείριση & Επικοινωνία', suggestion: 'Προτάσεις Βελτίωσης', complaint: 'Παράπονα ή Αναφορά Προβλήματος', other: 'Άλλο' },
  en: { cleaning: 'Cleaning of Common Areas', garden: 'Garden & Outdoor Areas', maintenance: 'Building Maintenance & Repairs', safety: 'Building Safety & Security', management: 'Management & Communication', suggestion: 'Suggestions for Improvement', complaint: 'Complaints or Problem Reports', other: 'Other' },
};
export const STATUSES = ['new', 'awaiting_management', 'awaiting_owner', 'in_progress', 'resolved', 'closed'];
export const OPEN_STATUSES = ['new', 'awaiting_management', 'awaiting_owner', 'in_progress'];
export const ACTION_STATUSES = ['new', 'awaiting_management'];
export const STATUS = {
  new: { el: 'Νέο αίτημα', en: 'New request', cls: 'bg-red-600 text-white' },
  awaiting_management: { el: 'Αναμονή απάντησης διαχείρισης', en: 'Awaiting management reply', cls: 'bg-orange-500 text-white' },
  awaiting_owner: { el: 'Αναμονή απάντησης ιδιοκτήτη', en: 'Awaiting owner reply', cls: 'bg-sky-600 text-white' },
  in_progress: { el: 'Σε εξέλιξη', en: 'In progress', cls: 'bg-blue-700 text-white' },
  resolved: { el: 'Επιλύθηκε', en: 'Resolved', cls: 'bg-emerald-600 text-white' },
  closed: { el: 'Κλειστό', en: 'Closed', cls: 'bg-zinc-500 text-white' },
};
export const fmtDateTime = (s) => (s ? new Date(s).toLocaleString('el-GR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—');
export const REQ_STATUS = {
  pending: { el: 'Αναμένεται απάντηση', en: 'Awaiting response', cls: 'text-amber-700 bg-amber-50 border-amber-200' },
  responded: { el: 'Απάντησε', en: 'Responded', cls: 'text-emerald-700 bg-emerald-50 border-emerald-200' },
  expired: { el: 'Έληξε', en: 'Expired', cls: 'text-zinc-500 bg-zinc-50 border-zinc-200' },
};
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString('el-GR') : '—');

export const Badge = ({ map, value, lang, testid }) => {
  const m = map[value] || {};
  return <span className={`text-[10px] uppercase tracking-wider font-semibold px-1.5 py-0.5 border border-transparent whitespace-nowrap ${m.cls || 'bg-zinc-100 text-zinc-500'}`} data-testid={testid}>{m[lang] || value}</span>;
};

export const Kpi = ({ label, value, tone = 'text-zinc-900', testid }) => (
  <div className="border border-zinc-200 bg-white p-3" data-testid={testid}>
    <div className="text-[10px] uppercase tracking-wider text-zinc-500">{label}</div>
    <div className={`text-2xl font-bold font-mono mt-1 ${tone}`}>{value ?? '—'}</div>
  </div>
);

export const KpiRow = ({ k = {}, lang, prefix }) => (
  <div className="grid grid-cols-2 md:grid-cols-7 gap-2">
    <Kpi label={L(lang, 'Προσκλήσεις', 'Invitations Sent')} value={k.invitations} testid={`${prefix}-invitations`} />
    <Kpi label={L(lang, 'Απαντήσεις', 'Responses')} value={k.responses} testid={`${prefix}-responses`} />
    <Kpi label={L(lang, 'Αναμονή απάντησης διαχείρισης', 'Awaiting management reply')} value={k.awaiting_management} tone={k.awaiting_management ? 'text-orange-600' : undefined} testid={`${prefix}-awaiting-management`} />
    <Kpi label={L(lang, 'Αναμονή ιδιοκτήτη', 'Awaiting owner')} value={k.awaiting_owner} testid={`${prefix}-awaiting-owner`} />
    <Kpi label={L(lang, 'Σε εξέλιξη', 'In progress')} value={k.in_progress} testid={`${prefix}-in-progress`} />
    <Kpi label={L(lang, 'Επιλυμένα', 'Resolved')} value={k.resolved} tone="text-emerald-700" testid={`${prefix}-resolved`} />
    <Kpi label={L(lang, 'Προτάσεις Βελτίωσης', 'Suggestions')} value={k.suggestions} testid={`${prefix}-suggestions`} />
  </div>
);
